import { render, staticRenderFns } from "./CapaianTargetPNBP.vue?vue&type=template&id=6b26b12a&"
import script from "./CapaianTargetPNBP.vue?vue&type=script&lang=js&"
export * from "./CapaianTargetPNBP.vue?vue&type=script&lang=js&"
import style0 from "./CapaianTargetPNBP.vue?vue&type=style&index=0&id=6b26b12a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports